import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx';
import { map } from 'rxjs/operators';

import { SamplePartialState, SampleActions } from './sample.state';
import { SampleService } from '../data-access.service';

@Injectable()
export class  SampleEffects {

  loadAllEntities$ = createEffect(() => this.dataPersistence.fetch(SampleActions.LoadAll.type, {
    run: (action: any, state) => this.apiService.getAll(action.payload)
                                      .pipe(map(response => SampleActions.LoadedAll({ payload: response }))),
    onError: (action: any, error) => SampleActions.ActionError(action + error)
  }));

  createEntity$ = createEffect(() => this.dataPersistence.pessimisticUpdate(SampleActions.Add.type, {
    run: (action: any, state) => this.apiService.add(action.payload)
                                      .pipe(map((response: any) => SampleActions.Added({ payload: response }))),
    onError: (action: any, error) => SampleActions.ActionError(action + error)
  }));

  updateEntity$ = createEffect(() => this.dataPersistence.pessimisticUpdate(SampleActions.Update.type, {
    run: (action: any, state) => this.apiService.update(action.payload)
                                      .pipe(map((response: any) => SampleActions.Updated({ payload: response }))),
    onError: (action: any, error) => SampleActions.ActionError(action + error)
  }));

  deleteEntity$ = createEffect(() => this.dataPersistence.pessimisticUpdate(SampleActions.Delete.type, {
    run: (action: any, state) => this.apiService.delete(action.payload)
                                      .pipe(map(response => SampleActions.Deleted({ payload: response }))),
    onError: (action: any, error) => SampleActions.ActionError(action + error)
  }));

  constructor(
    private dataPersistence: DataPersistence<SamplePartialState>,
    private apiService: SampleService,
  ) {}
}
// console.log(`%cSampleEffects::ngOnInit`, 'background:yellow');
